import { FunctionComponent } from 'react';
import Head from 'next/head';

// Components
import App from '@Components/Utils/App';
import Image from '@Components/Utils/Image';
import Modal from '@Pages/services/Components/Modal';
import ModalSuccess from '../Modal/Components/ModalSuccess';
import LayoutContainer from '@Components/Layout/Components/Container';
import Breadcrumb, { PathLevelProps } from '@Components/UI/Breadcrumb';
import { useViewDetected, ViewMedia } from '@Components/Utils/ViewDetected';

// Styles
import styles from './Banner.module.scss';

// Utilites
import classnames from 'classnames';
import { useServiceManager } from '../Contexts/service';
import { useAppStore } from '@Components/AppStore/Context';

interface bannerProps {
    title?: string;
    price?: string;
    bannerImg?: string;
    packageName?: string;
    breadcrumbName?: string;
}

const Banner: FunctionComponent<bannerProps> = ({ bannerImg, title, price, breadcrumbName, packageName }) => {
    const { isApp } = useAppStore();
    const { deviceType } = useViewDetected();
    const { isRegister, setPackageName, setIsRegister } = useServiceManager();

    const paths: Array<PathLevelProps> = [
        {
            label: 'Dịch vụ',
            path: '/dich-vu',
        },
        {
            label: breadcrumbName,
        },
    ];

    const className = classnames([
        styles.wrapper_banner,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
            [styles.is_app]: isApp,
        },
    ]);

    const handleOpenModal = () => {
        setIsRegister(!isRegister);
        setPackageName(packageName);
        gtag('event', 'click', {
            event_category: 'Services',
            event_label: 'View modal Register',
        });
    };

    const indexOf = title.indexOf('<br />');
    const subTitle = title.slice(0, indexOf);
    const mainTitle = title.slice(indexOf + 7, title.length);

    const handleScroll = () => {
        window.scrollTo(0, 720);
    };
    const isPageGenTest = breadcrumbName !== 'Xét nghiệm gen';

    const handleTrackingClickHotLine = () => {
        gtag('event', 'click', {
            event_category: 'Services',
            event_label: 'Services - hotline',
        });
    };

    return (
        <div className={className}>
            <Head>
                <link rel={'preload'} as={'image'} href={bannerImg} />
            </Head>
            <Modal />
            <ModalSuccess />

            <App is={false}>
                <LayoutContainer className={styles.wrapper_breadcrumb}>
                    <Breadcrumb
                        paths={paths}
                        colorClassName={isPageGenTest}
                        className={classnames([
                            styles.breadcrumb,
                            {
                                [styles.case_gen_test]: !isPageGenTest,
                            },
                        ])}
                        itemClassName={styles.route_item}
                    />
                </LayoutContainer>
            </App>

            <div className={styles.banner}>
                <App is={false}>
                    <Image
                        className={classnames([styles.banner_img], {
                            [styles.tablet]: deviceType === 'tablet',
                        })}
                        src={bannerImg}
                    />
                </App>

                <div className={styles.right_banner}>
                    <ViewMedia is={'desktop'}>
                        <Image className={styles.logo} src="assets/white_logo.png" />
                    </ViewMedia>

                    <div className={styles.content}>
                        <div className={styles.group_head}>
                            <div className={styles.group_title}>
                                <div>{subTitle}</div>
                                <div className={styles.title}>{mainTitle}</div>
                            </div>

                            <App is={false}>
                                <ViewMedia is={['mobile', 'tablet']}>
                                    <div className={styles.banner_price}>
                                        <span>Chỉ từ</span> {price}đ
                                    </div>
                                </ViewMedia>
                            </App>
                        </div>

                        <span className={styles.description}>
                            Xét nghiệm tại nhà, tiết kiệm thời gian,{deviceType !== 'desktop' && <br />} có kết quả
                            nhanh chóng.
                        </span>
                        <App is={false}>
                            <>
                                <button className={styles.button} onClick={handleOpenModal}>
                                    Đăng ký tư vấn miễn phí
                                </button>
                                <div className={styles.telephone}>
                                    <span className={styles.text}>Hoặc gọi ngay</span>
                                    <Image className={styles.icon_call} src="assets/dich-vu/icon_call.png" />
                                    <span onClick={handleTrackingClickHotLine} className={styles.phone}>
                                        19006115
                                    </span>
                                </div>
                            </>
                        </App>
                    </div>
                    <ViewMedia is="desktop">
                        <span onClick={handleScroll} className={styles.scroll_btn}>
                            <Image className={styles.image} src="assets/dich-vu/scroll.gif" />
                            {/* <a href="#">
                                <span className={styles.mouse_icon}>
                                    <span></span>
                                </span>
                            </a> */}
                        </span>
                    </ViewMedia>
                </div>
            </div>
        </div>
    );
};
Banner.defaultProps = {
    bannerImg: 'assets/dich-vu/banner_home_test.png',
    title: 'GÓI KHÁM <br /> TỔNG QUÁT',
    price: '499.000',
    breadcrumbName: 'Xét nghiệm tổng quát tại nhà',
};
export default Banner;
